<div [class]="containerClass">
  <textarea
    #textareaEl
    [id]="inputId"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [readonly]="readonly"
    [rows]="rows"
    [attr.maxlength]="maxlength || null"
    [attr.minlength]="minlength || null"
    [required]="required"
    class="hc-textarea__native"
    [value]="value"
    (input)="onInput($event)"
    (focus)="onFocus()"
    (blur)="onBlur()">
  </textarea>
</div>
